import React, { useEffect } from "react";
import {
  Authenticator,
  ThemeProvider as AmplifyThemeProvider,
  useAuthenticator,
} from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import HomeGuest from "./HomeGuest";
import { useContextData } from "../hooks/useContextData";
import { useTranslation } from "../context/I18nContext";
import { Box, Typography } from "@mui/material";
import { amplifyTheme } from "../theme/amplifyTheme";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { theme } = useContextData();
  const { t } = useTranslation();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  useEffect(() => {
    if (authStatus === "authenticated") {
      navigate("/");
    }
  }, [authStatus, navigate]);

  const colorMode = theme === "dark" ? "dark" : "light";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { md: "flex-start" },
        bgcolor: "background.default",
      }}
    >
      {/* Left: HomeGuest preview — scrolls with the page */}
      <Box sx={{ flex: "3 1 0%", minWidth: 0 }}>
        <HomeGuest />
      </Box>

      {/* Right: Auth panel — sticky, always visible in viewport */}
      <Box
        sx={{
          flex: { xs: "1 1 auto", md: "0 0 480px" },
          width: { xs: "100%", md: 480 },
          maxWidth: { xs: "100%", md: 480 },
          alignSelf: { xs: "center", md: "flex-start" },
          position: { md: "sticky" },
          top: { md: 0 },
          height: { xs: "auto", md: "100vh" },
          display: "flex",
          flexDirection: "column",
          overflowY: { md: "auto" },
          bgcolor: theme === "dark" ? "#0d1117" : "#f8f9fb",
        }}
      >
        <AmplifyThemeProvider theme={amplifyTheme} colorMode={colorMode}>
          <Authenticator socialProviders={["google", "apple"]} />
        </AmplifyThemeProvider>
        <Typography
          variant="body2"
          sx={{
            mt: "auto",
            pb: 3,
            px: 3,
            color: "text.secondary",
            textAlign: "center",
            lineHeight: 1.7,
            fontFamily: '"Inter", sans-serif',
            fontSize: "0.75rem",
          }}
        >
          {t("login.disclaimer")}
        </Typography>
      </Box>
    </Box>
  );
};

export default Login;
